export default {
  move: 'Move',
  delete: 'Delete',
  duplicate: 'Duplicate',
  actions: 'Actions',
  languages: 'Languages',
  search: 'Search',
  folders: 'Folders',
  label: 'Label',
  trash: 'Trash',
  images: 'Images',
  languages: 'Languages',
  postName: 'Post Name',
  added: 'Added Date',
  notes: 'Notes',
  countries: 'Countries',
  postEdit: 'Post Edit',
  postsPerPage: 'Posts per Page',
};
